import {
  AnimatedCheckMark,
  Button,
  Div,
  Text,
} from '@sendoutcards/quantum-design-ui'
import React from 'react'
import styles from './pointsPackage.module.scss'
import { useAccount } from 'src/hooks'
import { getPricePerPoint } from 'src/helpers'

interface SingleCardPackageProps {
  onSelect: (option: number, pricePerPoint: number, amount: number) => void
  isSelected: boolean
  option: number
}

const SingleCardPackage: React.FC<SingleCardPackageProps> = props => {
  const { onSelect, isSelected, option } = props
  const { pointPrice } = useAccount()
  const pricePerPoint = getPricePerPoint(pointPrice, 3)

  return (
    <Div
      boxShadow="mediumLight"
      className={`${styles.pointsPackage} ${styles.singleCardPackage}`}
      position="relative"
    >
      <Div
        position="absolute"
        width="100%"
        top="-28px"
        backgroundColor="#47ba6b"
      >
        <Text type="body" alignment="center" color="inverseBody">
          SINGLE CARD
        </Text>
      </Div>
      <Div className={styles.singleAmount}>
        <Text type="title">${3 * pricePerPoint}</Text>
      </Div>
      <Div className={styles.singleContent}>
        <img
          src="https://www.sendoutcards.com/static/images/cards/birthday_card.jpg"
          alt="example greeting card"
        />
        <Text type="footnote">Pays for a single 2-panel card or postcard.</Text>
      </Div>
      <Div className={styles.singleSelect}>
        {isSelected ? (
          <Div cursor="pointer" onClick={() => onSelect(0, 0, 0)}>
            <AnimatedCheckMark filled={true} size="medium" />
          </Div>
        ) : (
          <Button
            onClick={() => onSelect(option, pricePerPoint, 3)}
            size="small"
          >
            Select
          </Button>
        )}
      </Div>
    </Div>
  )
}

export default SingleCardPackage
